import {
  getCompletedAssessment,
  getNewAdmissionsNONPOAAsync,
  getNewAdmissionsPOAAsync,
  getNewWoundsNONPOAAsync,
  getNewWoundsPOAAsync,
  getOtherAssessmentNONPOAAsync,
  getOtherAssessmentPOAAsync,
  getPIAssessmentsNONPOAAsync,
  getPIAssessmentsPOAAsync,
  getWoundExpertAssessmentNONPOA,
  getWoundExpertAssessmentPOA,
  getWoundExpertDebridement,
  getWoundPhotoAsync,
} from "../../../app/workListSlice";
import {
  COMPLETED_ASSESSMENT,
  NEW_ADMISSION_NON_POA,
  NEW_ADMISSION_POA,
  NEW_WOUNDS_NON_POA,
  NEW_WOUNDS_POA,
  OTHER_ASSESSMENT_NON_POA,
  OTHER_ASSESSMENT_POA,
  PI_ASSESSMENT_NON_POA,
  PI_ASSESSMENT_POA,
  WOUND_EXPERT_ASSESSMENT_DEBRIDEMENT,
  WOUND_EXPERT_ASSESSMENT_NON_POA,
  WOUND_EXPERT_ASSESSMENT_POA,
  WOUND_PHOTO_WORKLIST,
} from "../../../constants";
import { LOADING_KEYS } from "../../../constants/loadingKeys";
import { NEW_ADMISSION_COLUMNS, NEW_WOUND_COLUMN, WOUND_PHOTO_COLUMNS } from "./worklistColumns";

export const WORKLIST_CONFIG = {
  woundPhotos: {
    loadingKey: LOADING_KEYS.WOUND_PHOTO_WORKLIST,
    url: WOUND_PHOTO_WORKLIST,
    asyncThunk: getWoundPhotoAsync,
    selectData: (state) => state.worklists.woundPhotoData,
    columns: WOUND_PHOTO_COLUMNS,
    listKey: "woundPhotoData",
  },
  newAdmissionsPOA: {
    loadingKey: LOADING_KEYS.NEW_ADDMISSION_POA,
    url: NEW_ADMISSION_POA,
    asyncThunk: getNewAdmissionsPOAAsync,
    selectData: (state) => state.worklists.newAdmissionPOAData,
    columns: NEW_ADMISSION_COLUMNS,
    listKey: "newAdmissions",
  },
  newAdmissionsNONPOA: {
    loadingKey: LOADING_KEYS.NEW_ADDMISSION_NONPOA,
    url: NEW_ADMISSION_NON_POA,
    asyncThunk: getNewAdmissionsNONPOAAsync,
    selectData: (state) => state.worklists.newAdmissionNONPOAData,
    columns: NEW_ADMISSION_COLUMNS,
    listKey: "newAdmissions",
  },
  newWoundsPOA: {
    loadingKey: LOADING_KEYS.NEW_WOUNDS_POA,
    url: NEW_WOUNDS_POA,
    asyncThunk: getNewWoundsPOAAsync,
    selectData: (state) => state.worklists.newWoundsPOAData,
    columns: NEW_WOUND_COLUMN,
    listKey: "newWounds",
  },
  newWoundsNONPOA: {
    loadingKey: LOADING_KEYS.NEW_WOUNDS_NON_POA,
    url: NEW_WOUNDS_NON_POA,
    asyncThunk: getNewWoundsNONPOAAsync,
    selectData: (state) => state.worklists.newWoundsNONPOAData,
    columns: NEW_WOUND_COLUMN,
    listKey: "newWounds",
  },
  piAssessmentsPOA: {
    loadingKey: LOADING_KEYS.PI_ASSESSMENT_POA,
    url: PI_ASSESSMENT_POA,
    asyncThunk: getPIAssessmentsPOAAsync,
    selectData: (state) => state.worklists.piAssessmentPOAData,
    columns: NEW_WOUND_COLUMN,
    listKey: "piAssessments",
  },
  piAssessmentsNONPOA: {
    loadingKey: LOADING_KEYS.PI_ASSESSMENT_NON_POA,
    url: PI_ASSESSMENT_NON_POA,
    asyncThunk: getPIAssessmentsNONPOAAsync,
    selectData: (state) => state.worklists.piAssessmentNONPOAData,
    columns: NEW_WOUND_COLUMN,
    listKey: "piAssessments",
  },
  otherAssessmentsPOA: {
    loadingKey: LOADING_KEYS.OTHER_ASSESSMENT_POA,
    url: OTHER_ASSESSMENT_POA,
    asyncThunk: getOtherAssessmentPOAAsync,
    selectData: (state) => state.worklists.otherAssessmentPOAData,
    columns: NEW_WOUND_COLUMN,
    listKey: "otherAssessments",
  },
  otherAssessmentsNONPOA: {
    loadingKey: LOADING_KEYS.OTHER_ASSESSMENT_NON_POA,
    url: OTHER_ASSESSMENT_NON_POA,
    asyncThunk: getOtherAssessmentNONPOAAsync,
    selectData: (state) => state.worklists.otherAssessmentNONPOAData,
    columns: NEW_WOUND_COLUMN,
    listKey: "otherAssessments",
  },
  woundExpertPOAStage: {
    loadingKey: LOADING_KEYS.WOUND_EXPERT_ASSESSMENT_POA,
    url: WOUND_EXPERT_ASSESSMENT_POA,
    asyncThunk: getWoundExpertAssessmentPOA,
    selectData: (state) => state.worklists.woundExpertAssessmetPOAData,
    columns: NEW_WOUND_COLUMN,
    listKey: "expertAssessments",
  },
  woundExpertPOAStageUnstage: {
    loadingKey: LOADING_KEYS.WOUND_EXPERT_ASSESSMENT_NON_POA,
    url: WOUND_EXPERT_ASSESSMENT_NON_POA,
    asyncThunk: getWoundExpertAssessmentNONPOA,
    selectData: (state) => state.worklists.woundExpertAssessmetNONPOAData,
    columns: NEW_WOUND_COLUMN,
    listKey: "expertAssessments",
  },
  woundExpertDebridement: {
    loadingKey: LOADING_KEYS.WOUND_EXPERT_ASSESSMENT_DEBRIDEMENT,
    url: WOUND_EXPERT_ASSESSMENT_DEBRIDEMENT,
    asyncThunk: getWoundExpertDebridement,
    selectData: (state) => state.worklists.woundExpertAssessmentDebridementData,
    columns: NEW_WOUND_COLUMN,
    listKey: "expertAssessments",
  },
  reviewLockedAssessment: {
    loadingKey: LOADING_KEYS.COMPLETED_ASSESSMENT,
    url: COMPLETED_ASSESSMENT,
    asyncThunk: getCompletedAssessment,
    selectData: (state) => state.worklists.completedAssessmentData,
    columns: NEW_WOUND_COLUMN,
    listKey: "completedAssessments",
  },
};
